import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";

const ComponentEditConfig = {
    emptyLabel: "Compare - Overlay Grid",
    isEmpty: function (props) {
        return !props || !props.other || props.other.trim().length < 1;
    },
};

const transformData = (props) => {
    const transformed = { ...props.media || {} };
    return transformed;
};

const CompareOverlay = (props) => {
    const data = transformData(props);
    return <div />;
};

export default withAemIntegration("lexus/components/content/compare/compare-overlay")(
    CompareOverlay,
    ComponentEditConfig
);
